import { Button, message, Space } from 'antd'
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Proceeding as ProceedingType } from '../../common/proceedingTypes'
import { Fade } from '../components/Fade/Fade'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { ProceedingDetail } from '../components/ProceedingDetail/ProceedingDetail'
import { ProceedingSearchBar } from '../components/ProceedingSearchBar/ProceedingSearchBar'
import { proceedingDetailPath } from '../utils/paths'
import { getProceedingKey } from '../utils/proceedingDetailHelpers'
import { parseProceedingUrlQuery } from '../utils/proceedingSearchHelpers'
import { useInitialFetchWatchdog } from '../utils/useFetchWatchdog'
import { useFormattedProceeding } from '../utils/useProceedingString'
import { useProceedingWindow } from '../utils/useProceedingWindow'

export const Proceeding: FunctionComponent = () => {
  useInitialFetchWatchdog()
  const history = useHistory()
  const {
    params: { urlQuery },
  } = useRouteMatch<{ urlQuery: string }>()

  const [proceeding, setProceeding] = useState<ProceedingType | undefined>()
  const { proceedingTitle, proceedingKey } = useFormattedProceeding(proceeding)

  useEffect(() => {
    if (!urlQuery || urlQuery === proceedingKey) return

    const parsed = parseProceedingUrlQuery(urlQuery)
    if (!parsed?.pracovisteKod) {
      message.error('Špatný formát čísla řízení')
      history.push(proceedingDetailPath())
      return
    }

    setProceeding(parsed)
  }, [history, proceedingKey, urlQuery])

  const [refreshKey, setRefreshKey] = useState(0)

  const handleWindowClose = useCallback(() => {
    setRefreshKey(prev => prev + 1)
  }, [])

  const { openWindow } = useProceedingWindow(proceeding, handleWindowClose)

  const handleSetProceeding = useCallback(
    (proceeding?: ProceedingType) => {
      setProceeding(proceeding)
      history.push(
        proceedingDetailPath(
          proceeding ? getProceedingKey(proceeding) : undefined
        )
      )
    },
    [history]
  )

  const extra = useMemo(
    () => (
      <Space>
        {proceedingKey && (
          <Button onClick={openWindow} type="primary" ghost>
            Zobrazit v ČÚZK
          </Button>
        )}
        <Button onClick={() => handleSetProceeding(undefined)} type="primary">
          Vyhledat nové řízení
        </Button>
      </Space>
    ),
    [handleSetProceeding, openWindow, proceedingKey]
  )

  return (
    <>
      {!proceeding && (
        <PageLayout title="Vyhledat řízení" className="pb-0">
          <ProceedingSearchBar
            initialValues={urlQuery}
            setProceeding={handleSetProceeding}
          />
        </PageLayout>
      )}
      <Fade show={!!proceeding}>
        <PageLayout
          title={`Detail řízení ${proceedingTitle || ''}`}
          className="py-8"
          extra={extra}
        >
          <ProceedingDetail
            setProceeding={handleSetProceeding}
            proceeding={proceeding}
            refreshKey={refreshKey}
            onOpenCuzkWindow={openWindow}
          />
        </PageLayout>
      </Fade>
    </>
  )
}

export default Proceeding
